<h2 mat-dialog-title>Vincular trabajador</h2>
<mat-dialog-content>
  <p class="text-muted">
    Este equipo se entregó antes de que el trabajador estuviera cargado en el sistema.
    Busca por rut al trabajador ya existente para vincularlo a este movimiento.
  </p>
  <div class="row">
    <div class="col-12">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Rut trabajador</mat-label>
        <input matInput [(ngModel)]="rutBusqueda" (input)="onRutInput($event)" placeholder="Ej: 12.345.678-9" />
      </mat-form-field>
      <div *ngIf="sugerencias.length > 0" class="list-group">
        <button type="button" class="list-group-item list-group-item-action" *ngFor="let t of sugerencias"
                (click)="seleccionarTrabajador(t)">
          {{ t.rut | formatoRut }} - {{ t.nombres }} {{ t.apellidos }}
        </button>
      </div>
      <button mat-stroked-button color="primary" type="button" [disabled]="buscando" (click)="buscarPorRut()">
        <mat-icon>search</mat-icon>
        Buscar
      </button>
    </div>
  </div>

  <div *ngIf="buscado && !trabajadorSeleccionado" class="text-muted mt-2">
    No se encontró ningún trabajador con ese rut.
  </div>

  <div *ngIf="trabajadorSeleccionado" class="alert alert-success mt-2">
    Se vinculará a: {{ trabajadorSeleccionado.nombres }} {{ trabajadorSeleccionado.apellidos }}
    ({{ trabajadorSeleccionado.rut | formatoRut }})
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancelar()">Cancelar</button>
  <button mat-raised-button color="primary" type="button" [disabled]="!trabajadorSeleccionado || vinculando" (click)="vincular()">Vincular</button>
</mat-dialog-actions>
